import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  createMakeUpSessionRequest: ["children_id"],
  createMakeUpSessionSuccess: ["makeupdata"],
  createMakeUpSessionFailure: null,
});

export const CreateMakeUpSessionTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: null,
  makeupdata: null,
  error: null,
  children_id: null,
});

export const CreateMakeUpSessionSelectors = {
  getData: (state: any) => state.createMakeUpSession.data,
  isFetching: (state: any) => state.createMakeUpSession.fetching,
  isSuccess: (state: any) => state.createMakeUpSession.success,
  hasError: (state: any) => state.createMakeUpSession.error,
};

export const request = (state: any, { children_id }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    makeupdata: null,
    children_id: children_id,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { makeupdata } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    makeupdata,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    makeupdata: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CREATE_MAKE_UP_SESSION_REQUEST]: request,
  [Types.CREATE_MAKE_UP_SESSION_SUCCESS]: success,
  [Types.CREATE_MAKE_UP_SESSION_FAILURE]: failure,
});
